export default "__VITE_ASSET__DQYdcJFn__"